// extracted by mini-css-extract-plugin
module.exports = {"carousel__btn":"fa4482","carousel__btn-disable":"_93378f","carousel__btn__loader":"_29780c"};